import React from 'react'
import { PageTitle, WithPageTitle } from '@morningtrain/react-app'
import { useValue } from '@morningtrain/react-resources'

export default function ModelValueTitle ({ name = 'title', display = true }) {
  const value = useValue(name)

  return (
    <>
      <WithPageTitle title={value} />
      {display === true ? <PageTitle /> : null}
    </>
  )
}
